import 'regenerator-runtime/runtime'
import App from './App'
import render from 'commons/js/util/render'
import scrollTo from './util/scrollTo'
import { init } from 'commons/js/util/reporter'

init()

document.querySelector('.js-btn-go-to-shop').addEventListener('click', () => {
    scrollTo(document.querySelector('.landing-merchants__coupon-packs').offsetTop)
})

const list = document.querySelectorAll('.js-coupon-pack-selector')

// Thanks IE11 for not supporting forEach on NodeList
Array.prototype.forEach.call(list, (element) => {
    render({ App, element, props: {dataSet: element.dataset} })
})
